/**
 * Buttons settings to generate atomic classes.
 *
 * WARNING!!! `key` are required.
 * Other are used in iCMS
 */
const button = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'button', title: 'Button' },
    { key: 'button-1', title: 'Button 1' },
    { key: 'button-inline', title: 'Text Button' },
    { key: 'button-inline-1', title: 'Text Button 1', sgClass: 'sg-bg-button-inline-1', libraryDarkBackground: true },
];
exports.button = button;
